export const privacy = {
  "header": {
    "badge": "Datos personales",
    "title": "política de privacidad"
  },
  "content": {
    "intro": "La protección de su privacidad y de sus datos personales es una prioridad absoluta para DONKEY TRAVEL. Esta política detalla cómo recopilamos, procesamos y aseguramos su información.",
    "collection": {
      "title": "1. Recopilación de datos",
      "text": "Solo recopilamos los datos estrictamente necesarios para el correcto funcionamiento de la plataforma: información de creación de su cuenta (apellido, nombre, correo electrónico), enlaces a sus anuncios públicos (Airbnb) y sus preferencias y disponibilidad de viaje. Las contraseñas están cifradas y los datos de pago son procesados ​​por nuestro socio seguro Stripe."
    },
    "usage": {
      "title": "2. Uso de tus datos",
      "text": "Su información se utiliza para: \n- Verifique su elegibilidad (calificación 4.5+) \n- Gestiona tu suscripción \n- Facilitar la conexión con otros miembros. \n- Proporcione recomendaciones personalizadas a través de nuestro Matching inteligente \n- Mejorar nuestros servicios y resolver problemas técnicos."
    },
    "sharing": {
      "title": "3. Intercambio de información",
      "text": "NUNCA venderemos tus datos personales a terceros. Su intercambio se limita estrictamente a fines operativos con nuestros proveedores de servicios de confianza (alojamiento web, herramienta de pago). Fuera de este marco, sus datos sólo se comparten entre miembros para la organización de un intercambio (y sólo la dirección exacta después de la validación de un intercambio)."
    },
    "security": {
      "title": "4. Seguridad",
      "text": "Contamos con los protocolos de seguridad y autenticación más sólidos para proteger sus datos contra el acceso no autorizado, la alteración, la divulgación o la destrucción."
    },
    "rights": {
      "title": "5. Tus derechos (RGPD)",
      "text": "De acuerdo con el Reglamento General de Protección de Datos, usted tiene derecho a acceder, rectificar, portabilidad o suprimir sus datos personales en cualquier momento. Puede ejercer este derecho desde la configuración de su cuenta o escribiéndonos a dpo@donkey.travel."
    },
    "cookies": {
      "title": "6. Galletas",
      "text": "Utilizamos cookies esenciales para mantener su sesión de inicio de sesión, así como cookies analíticas anónimas para comprender cómo se utiliza nuestro sitio y mejorar su experiencia."
    }
  }
};
